const sectionItemsGridMediaCss = `
[data-type='section-items-grid-media'] .items-grid-media-wrapper {
  background-color: var(--background-color, #ffffff);
  color: var(--text-color, #000000);
}

[data-type='section-items-grid-media'] .items-grid-media-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-items-grid-media'] .items-grid-media-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-items-grid-media'] .items-grid-media-header:not(:empty) {
  margin-bottom: 32px;
}

[data-type='section-items-grid-media'] .items-grid-media-header h1,
[data-type='section-items-grid-media'] .items-grid-media-header h2,
[data-type='section-items-grid-media'] .items-grid-media-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-items-grid-media'] .items-grid-media-header h1:last-child,
[data-type='section-items-grid-media'] .items-grid-media-header h2:last-child,
[data-type='section-items-grid-media'] .items-grid-media-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-media'] .items-grid-media-header p {
  font-size: 18px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-items-grid-media'] .items-grid-media-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-media'] .items-grid-media-list {
  --items-gap: 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: var(--items-gap);
}

[data-type='section-items-grid-media'] .items-grid-media-item {
  --item-basis-desktop: calc(
    (100% - (var(--items-per-row-desktop, 5) - 1) * var(--items-gap)) / var(--items-per-row-desktop, 5)
  );
  --item-basis-mobile: calc(
    (100% - (var(--items-per-row-mobile, 2) - 1) * var(--items-gap)) / var(--items-per-row-mobile, 2)
  );

  flex: 0 0 var(--item-basis-desktop);
  max-width: var(--item-basis-desktop);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-video {
  position: relative;
  width: 100%;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-video iframe,
[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-video video {
  width: 100%;
  height: var(--video-height, 315px);
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-video .volume {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-video .volume svg {
  width: 20px;
  height: 20px;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h1,
[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h2,
[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h3 {
  font-size: 18px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h1:last-child,
[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h2:last-child,
[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content p {
  font-size: 16px;
  margin: 0 0 4px 0 !important;
  line-height: normal;
}

[data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-items-grid-media'] .items-grid-media-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-header:not(:empty) {
    margin-bottom: 24px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-header h1,
  [data-type='section-items-grid-media'] .items-grid-media-header h2,
  [data-type='section-items-grid-media'] .items-grid-media-header h3 {
    font-size: 20px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-header p {
    font-size: 14px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-item {
    flex-basis: var(--item-basis-mobile);
    max-width: var(--item-basis-mobile);
    gap: 4px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h1,
  [data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h2,
  [data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content h3 {
    font-size: 20px;
  }

  [data-type='section-items-grid-media'] .items-grid-media-item .items-grid-media-item-content p {
    font-size: 14px;
  }
}
`;
export default sectionItemsGridMediaCss;
